import React from 'react';
import type { DashboardEditableSpaWrapper } from '@atlassian/jira-spa-apps-servicedesk-project-dashboards/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskProjectDashboardsEditable = lazyForPaint<
	typeof DashboardEditableSpaWrapper
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-project-dashboards-dashboard-editable", jiraSpaEntry: "async-servicedesk-project-dashboards-dashboard-editable" */ '@atlassian/jira-spa-apps-servicedesk-project-dashboards'
		).then((module) => module.DashboardEditableSpaWrapper),
	),
);

export const ProjectDashboardsEditable = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskProjectDashboardsEditable}
		pageId="spa-apps/servicedesk-project-dashboards-editable"
		shouldShowSpinner
	/>
);
